import { render, staticRenderFns } from "./OneCareAppPasswordModal.vue?vue&type=template&id=36ef20c1&scoped=true"
import script from "./OneCareAppPasswordModal.vue?vue&type=script&lang=js"
export * from "./OneCareAppPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./OneCareAppPasswordModal.vue?vue&type=style&index=0&id=36ef20c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef20c1",
  null
  
)

export default component.exports